import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/layouts/Split/split';
import { css } from '@patternfly/react-styles';
export var SplitItem = function SplitItem(_a) {
  var _a$isFilled = _a.isFilled,
      isFilled = _a$isFilled === void 0 ? false : _a$isFilled,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      props = __rest(_a, ["isFilled", "className", "children"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.splitItem, isFilled && styles.modifiers.fill, className)
  }), children);
};